import React, { useState, useEffect, useRef, useContext } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Popconfirm,
    ProTableOt,
    useProTableOt,
    setParamsFilter,
    Tabs,
    MainModal,
    Form,
    ExpandableText,
    Typography,
    Input,
    PatchButton,
    Tag
} from "../../ui/ot";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from '../../ui/card'
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import useWindowSize from '../../online_public_catalog_query_construction/controllers/window_size';
import { useTranslation } from "react-i18next";
import { Clock, RotateCw, Mail, Calendar } from "lucide-react"
import { Badge } from "../../ui/badge"
import OverdueChangeForm from "./overdue_change_form"
import dayjs from "dayjs"
import axios from 'axios'
import { useSearchParams, useNavigate } from "react-router-dom";
import { BorrowedBooksModal } from "./book_return";
import CheckoutForm from "./checkout_form";
import { LibraryContext } from './library_context'


const OverdueProcessing = () => {
    const [activeKey, setActiveKey] = useState('全部')
    return (<Row>
        <Col span={24}>
            <Tabs
                activeKey={activeKey}
                onChange={(value) => { setActiveKey(value) }}
                items={[
                    {
                        key: "全部",
                        tab: "全部"
                    },
                    {
                        key: "已逾期",
                        tab: "已逾期"
                    },
                    {
                        key: "一週內逾期",
                        tab: "一週內逾期"
                    },
                    {
                        key: "未逾期",
                        tab: "借閱中"
                    },
                ]}
            />
        </Col>
        <Col span={24}>
            <OverdueProcessingTable propsIssueDaysDueStatus={activeKey} />
        </Col>
    </Row>)
}
const OverdueProcessingTable = ({
    keyPrefix = "library.backstage.overdue_processing",
    rowKey = "issue_id",
    propsIssueDaysDueStatus = "",
    propsIssueCardnumber,
    showReturn = false,
    onChange=()=>{}
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef();
    const [form] = Form.useForm();
    const [checkout_form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false)
    const [checkoutModalOpen, setCheckoutModalOpen] = useState(false)
    const [borrowedBookModalOpen, setBorrowedBookModalOpen] = useState(false)
    const [showBorrowernumber, setShowBorrowernumber] = useState(null)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [excelLoading, setExcelLoading] = useState(false);
    const { branchcode, branchname } = useContext(LibraryContext);
    const [checkInloading, setCheckInloading] = useState(false)

    const navigate = useNavigate()

    const [search, setSearch] = useState({
        issue_date_due_start: dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
        issue_date_due_end: dayjs().format('YYYY-MM-DD'),
        issue_issuedate_start: null,
        issue_issuedate_end: null,
    })
    const columns = [
        {
            title: t(`item_barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',

        },
        {
            title: t(`book_title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 300,
            render: (text, record, index) => {
                return (<Row>
                    <Col span={24}
                        style={{
                            cursor: "pointer",
                            color: "blue",
                            textDecoration: "underline"
                        }}
                        onClick={() => {
                            navigate(`/library/backstage/BookDetail?bib_biblionumber=${record?.bib_biblionumber}`)
                        }}>
                        <ExpandableText
                            text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}
                            maxLines={2}
                        />
                    </Col>
                </Row>)
            }
        },
        {
            title: t(`borrowing_branch`),
            dataIndex: 'issue_branchname',
            key: 'issue_branchname',

        },
        {
            title: t(`borrower`),
            dataIndex: 'staff_name',
            key: 'staff_name',
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col
                        style={{
                            cursor: "pointer",
                            color: "blue",
                            textDecoration: "underline"
                        }}
                        onClick={() => {
                            setBorrowedBookModalOpen(true)
                            setShowBorrowernumber(record?.issue_borrowernumber)
                        }}>
                        {text}
                    </Col>
                </Row>)
            }
        },
        {
            title: "卡號",
            dataIndex: 'issue_borrower_cardnumber',
            key: 'issue_borrower_cardnumber',
        },
        {
            title: "單位資訊",
            dataIndex: 'user_department_role_data',
            key: 'user_department_role_data',
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        {record?.user_department_role_data && record?.user_department_role_data?.map((value) => (<>
                            <Tag color="geekblue">
                                {
                                    value?.role_name_language_data?.[0]?.language_culture_value ?? ''
                                }
                                {value?.user_role_department_data && <>
                                    －
                                    {value?.user_role_department_data?.map(itemItem => itemItem?.department_language_data?.[0]?.language_culture_value ?? '').join('、')}
                                </>}
                            </Tag>
                        </>))}
                    </Col>
                </Row>)
            }

        },
        {
            title: t(`borrow_date`),
            dataIndex: 'issue_issuedate',
            key: 'issue_issuedate',
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col >
                        {dayjs(text).format("YYYY-MM-DD")}
                    </Col>
                </Row>)
            }
        },
        {
            title: t(`due_date`),
            dataIndex: 'issue_date_due',
            key: 'issue_date_due',
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col >
                        {dayjs(text).format("YYYY-MM-DD")}
                    </Col>
                </Row>)
            }
        },
        {
            title: t(`note`),
            dataIndex: 'issue_note',
            key: 'issue_note',
        },
        {
            title: t(`overdue_status`),
            dataIndex: 'issue_days_due_status',
            key: 'issue_days_due_status',
        },
        {
            title: t(`actions`),
            dataIndex: 'issue_date_due',
            key: 'issue_date_due',
            render: (text, record, index) => {
                return <Row justify="center" gutter={[8, 8]}>
                    {(record?.issue_days_due_status === "一週內逾期") && <Col>
                        <Popconfirm
                            title={t('confirm_renewal')}
                            description={t('renewal_prompt')}
                            onConfirm={() => {
                                KohaCheckoutRenewController.postData([
                                    {
                                        "issue_id": record?.issue_id,  //必填*
                                    }
                                ])
                            }}
                        >
                            <Button
                                disabled={!record?.issue_allow_renewal}
                            >
                                <RotateCw className="mr-2 h-4 w-4" />
                                {t('renew')}
                            </Button>
                        </Popconfirm>
                    </Col>}
                    <Col>
                        <Button
                            className="bg-[#e84f75] hover:bg-[#db899d] text-white"

                            onClick={() => {
                                form.setFieldsValue({
                                    ...record,
                                    issue_date_due: dayjs(record?.issue_date_due).format("YYYY-MM-DD")
                                })
                                setModalOpen(true)
                            }}>
                            <Calendar className="h-4" /> {t(`change_due_date`)}
                        </Button>
                    </Col>
                    {/* <Col>
                        <Button
                            className="bg-[#1976d2] hover:bg-[#4c8bc9] text-white"
                            onClick={() => {
                                sendMail([record])
                            }}>
                            <Mail className="h-4" /> 寄送通知
                        </Button>
                    </Col> */}
                    <Col>
                        <Button
                            className="bg-[#BBDEFB] hover:bg-[#95bee0] text-[#1976D2]"
                            onClick={() => {
                                setCheckoutModalOpen(true)
                                checkout_form.setFieldsValue({
                                    issue_id: record?.issue_id,
                                    note: record?.issue_note
                                })
                            }}>
                            編輯備註
                        </Button>
                    </Col>
                    {showReturn &&
                        <Col>
                            <Popconfirm
                                title="歸還書籍"
                                description={"確定要將此書籍歸還嗎？"}
                                onConfirm={() => {
                                    CheckInController.postData([{
                                        itemnumber: record?.item_itemnumber,
                                        biblionumber: record?.bib_biblionumber,
                                        borrowernumber: record?.issue_borrowernumber,
                                        branchcode: branchcode
                                    }])
                                }}
                            >
                                <Button
                                    className="bg-[#8d96f9] hover:bg-[#6e78eb] text-[#ffffff]"
                                >
                                    歸還書籍
                                </Button>
                            </Popconfirm>
                        </Col>}
                </Row>
            }
        },

    ];
    const showCard = {
        xxl: 4,
        xl: 3,
        lg: 3,
        md: 2,
        sm: 2,
        xs: 1,
    }
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.customer_service_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.customer_service_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.customer_service_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.customer_service_id
                );
                selectRow = selectRow.filter(
                    (row) => row.customer_service_id !== record.customer_service_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    // 螢幕大小斷點判斷
    function getBreakpoint(width) {
        const breakpoints = {
            xxl: 1600,
            xl: 1200,
            lg: 992,
            md: 768,
            sm: 576,
            xs: 0,
        };
        if (width >= breakpoints.xxl) return 'xxl';
        if (width >= breakpoints.xl) return 'xl';
        if (width >= breakpoints.lg) return 'lg';
        if (width >= breakpoints.md) return 'md';
        if (width >= breakpoints.sm) return 'sm';
        return 'xs';
    }
    const onRenewFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('renew_success'))
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.success(t('update_success'))
                actionRef.current.reload();
            }
            else if (axiosMode === "delete") {
                message.success(t('delete_success'))
                actionRef.current.reloadAndRest();
            }
            if (axiosMode !== "get") {
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                if (values === "Renewal not authorized (too_many)") {
                    message.error(t('renew_failure_limit'))
                }
                else if (values === "Renewal not authorized (too_soon)") {
                    message.error(t('renew_failure_not_open'))
                }
                else if (values === "Renewal not authorized (on_reserve)") {
                    message.error(t('renew_failure_reserved'))
                }
                else message.error(t('renew_failure'))
            }
            else if (axiosMode === "patch") {
                message.error(t('update_failure'))
            }
            else if (axiosMode === "delete") {
                message.error(t('delete_failure'))
            }
            actionRef.current.reloadAndRest();
            setModalOpen(false)

        }
    }
    const onFormFinish = (value) => {
        LibraryCheckoutController.patchData([
            {
                "issue_id": value?.issue_id,  //必填*
                due_date: value?.issue_date_due
            }
        ])
    }
    const onCheckoutFormFinish = (value) => {
        LibraryCheckoutController.patchData([
            {
                issue_id: value?.issue_id,
                note: value?.note || "",
            }
        ])
    }
    const onCheckoutFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('renew_success'))
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.success(t('update_success'))
                actionRef.current.reload();
            }
            else if (axiosMode === "delete") {
                message.success(t('delete_success'))
                actionRef.current.reloadAndRest();
            }
            if (axiosMode !== "get") {
                setModalOpen(false)
                setCheckoutModalOpen(false)

            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                if (values === "Renewal not authorized (too_many)") {
                    message.error(t('renew_failure_limit'))
                }
                else if (values === "Renewal not authorized (too_soon)") {
                    message.error(t('renew_failure_not_open'))
                }
                else if (values === "Renewal not authorized (on_reserve)") {
                    message.error(t('renew_failure_reserved'))
                }
                else message.error(t('renew_failure'))
            }
            else if (axiosMode === "patch") {
                message.error(t('update_failure'))
            }
            else if (axiosMode === "delete") {
                message.error(t('delete_failure'))
            }
            actionRef.current.reloadAndRest();
            setModalOpen(false)
            setCheckoutModalOpen(false)

        }
    }
    const sendMail = (data) => {
        // SendMailController.postData(data)
    }
    const getExcel = () => {
        setExcelLoading(true)
        axios.get('/library/koha/checkout/export/excel', {
            responseType: 'blob',
            params: {
                // cur_page: 1,
                // size: 1000,
                // checkout_start_time: checkout[0].format("YYYY-MM-DD"),
                // checkout_end_time: checkout[1].format("YYYY-MM-DD"),
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `續借及逾期處理.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
            .finally(() => {
                setExcelLoading(false)
            })
    };
    const onCheckInBefore = ({ axiosMode, status, values }) => {
        setCheckInloading(true)
    }
    const onCheckInFinish = ({ axiosMode, status, values }) => {
        // propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("歸還成功")
                setCheckInloading(false)
                actionRef.current.reloadAndRest();
                onChange()
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                setCheckInloading(false)
                message.error("歸還失敗")
                actionRef.current.reloadAndRest();
                onChange()
            }
        }
    }
    //取得螢幕大小
    const { width, height } = useWindowSize();
    const SendMailController = useCRUDController({
        // apiRoute: "/library/koha/checkout",
    })
    const LibraryCheckoutController = useCRUDController({
        apiRoute: "/library/koha/checkout",
        onFinish: onCheckoutFinish,

    })
    const KohaCheckoutRenewController = useCRUDController({
        apiRoute: "/koha/checkout/renew",
        onFinish: onRenewFinish
    })

    const CheckInController = useCRUDController({
        apiRoute: "/library/koha/checkin",
        onBefore: onCheckInBefore,
        onFinish: onCheckInFinish,
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [propsIssueDaysDueStatus, propsIssueCardnumber])
    return (<Row gutter={[16, 0]}>
        <Col>
            <BorrowedBooksModal
                borrowernumber={showBorrowernumber}
                propsSetOpen={setBorrowedBookModalOpen}
                propsOpen={borrowedBookModalOpen}
            />
        </Col>
        <Col>
            <MainModal
                propsLoading={false}
                axiosMode={'patch'}
                propsForm={form}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                onFinish={onFormFinish}
                width={600}
                formElement={<OverdueChangeForm />}
                keyPrefix={keyPrefix}
            />
        </Col>
        <Col>
            <MainModal
                propsLoading={false}
                axiosMode={'patch'}
                propsForm={checkout_form}
                propsOpen={checkoutModalOpen}
                propsSetOpen={setCheckoutModalOpen}
                onFinish={onCheckoutFormFinish}
                width={600}
                formElement={<CheckoutForm />}
                keyPrefix={keyPrefix}
            />
        </Col>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    issue_days_due_status: propsIssueDaysDueStatus,
                    cardnumber: propsIssueCardnumber,
                    ...search
                }}
                check={check}
                setCheck={setCheck}
                reloadButton={false}
                manageColumnsButton={false}
                showSearch={true}
                readonly={true}
                actionRef={actionRef}
                showMode="page"
                headerTitle={
                    <>

                    </>
                }
                columns={columns}
                rowKey={rowKey}
                toolBarRender={() => {
                    return [
                        // <Col span={24}>
                        //     <Row gutter={[4, 4]} align={"middle"}>
                        //         <Col>
                        //             <Typography.P>
                        //                 {t(`due_date`)}:
                        //             </Typography.P>
                        //         </Col>
                        //         <Col>
                        //             <Input
                        //                 type="date"
                        //                 // granularity={"day"}
                        //                 // placeholder={t(`.issue_date_due_start`)}
                        //                 format={"YYYY-MM-DD"}
                        //                 value={search?.issue_date_due_start ? search?.issue_date_due_start : ""}
                        //                 onChange={(e) => {
                        //                     setSearch((pre) => {
                        //                         if (dayjs(e.target.value).isBefore(dayjs(pre?.issue_date_due_end, "YYYY-MM-DD"))) {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_date_due_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                        //                             }
                        //                         }
                        //                         else {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_date_due_start: pre?.issue_date_due_end,
                        //                                 issue_date_due_end: e.target.value,
                        //                             }
                        //                         }

                        //                     })
                        //                 }}
                        //             />
                        //         </Col>
                        //         <Col>
                        //             <Typography.Title level={4}>
                        //                 ~
                        //             </Typography.Title>
                        //         </Col>
                        //         <Col>
                        //             <Input
                        //                 type="date"
                        //                 placeholder={t(`issue_date_due_end`)}
                        //                 format={"YYYY-MM-DD"}
                        //                 value={search?.issue_date_due_end ? search?.issue_date_due_end : ""}
                        //                 onChange={(e) => {
                        //                     setSearch((pre) => {
                        //                         if ((dayjs(e.target.value)).isBefore(pre?.issue_date_due_start)) {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_date_due_start: e.target.value,
                        //                                 issue_date_due_end: pre?.issue_date_due_start,
                        //                             }
                        //                         }
                        //                         else {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_date_due_end: e.target.value,
                        //                             }
                        //                         }

                        //                     })
                        //                 }}
                        //             />
                        //         </Col>
                        //         {(search?.issue_date_due_start || search?.issue_date_due_end) &&
                        //             <Col>
                        //                 <Button
                        //                     type={"icon"}
                        //                     onClick={() => {
                        //                         setSearch((pre) => {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_date_due_start: null,
                        //                                 issue_date_due_end: null
                        //                             }
                        //                         })
                        //                     }}>
                        //                     X
                        //                 </Button>
                        //             </Col>
                        //         }
                        //     </Row>
                        // </Col>,
                        // <Col span={24}>
                        //     <Row gutter={[4, 4]} align={"middle"}>
                        //         <Col>
                        //             <Typography.P>
                        //                 {t(`borrow_date`)}:
                        //             </Typography.P>
                        //         </Col>
                        //         <Col>
                        //             <Input
                        //                 type="date"
                        //                 // granularity={"day"}
                        //                 // placeholder={t(`.issue_date_due_start`)}
                        //                 format={"YYYY-MM-DD"}
                        //                 value={search?.issue_issuedate_start ? search?.issue_issuedate_start : ""}
                        //                 onChange={(e) => {
                        //                     setSearch((pre) => {
                        //                         if (dayjs(e.target.value).isBefore(dayjs(pre?.issue_issuedate_end, "YYYY-MM-DD"))) {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_issuedate_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                        //                             }
                        //                         }
                        //                         else {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_issuedate_start: pre?.issue_issuedate_end,
                        //                                 issue_issuedate_end: e.target.value,
                        //                             }
                        //                         }

                        //                     })
                        //                 }}
                        //             />
                        //         </Col>
                        //         <Col>
                        //             <Typography.Title level={4}>
                        //                 ~
                        //             </Typography.Title>
                        //         </Col>
                        //         <Col>
                        //             <Input
                        //                 type="date"
                        //                 placeholder={t(`issue_issuedate`)}
                        //                 format={"YYYY-MM-DD"}
                        //                 value={search?.issue_issuedate_end ? search?.issue_issuedate_end : ""}
                        //                 onChange={(e) => {
                        //                     setSearch((pre) => {
                        //                         if ((dayjs(e.target.value)).isBefore(pre?.issue_issuedate_start)) {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_issuedate_start: e.target.value,
                        //                                 issue_issuedate_end: pre?.issue_issuedate_start,
                        //                             }
                        //                         }
                        //                         else {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_issuedate_end: e.target.value,
                        //                             }
                        //                         }

                        //                     })
                        //                 }}
                        //             />

                        //         </Col>
                        //         {(search?.issue_issuedate_start || search?.issue_issuedate_end) &&
                        //             <Col>
                        //                 <Button
                        //                     type={"icon"}
                        //                     onClick={() => {
                        //                         setSearch((pre) => {
                        //                             return {
                        //                                 ...pre,
                        //                                 issue_issuedate_start: null,
                        //                                 issue_issuedate_end: null
                        //                             }
                        //                         })
                        //                     }}>
                        //                     X
                        //                 </Button>
                        //             </Col>
                        //         }
                        //     </Row>
                        // </Col>,
                        <Button
                            loading={excelLoading}
                            type='text'
                            style={{
                                color: "#fff",
                                backgroundColor: "#56b673"
                            }}
                            onClick={() => {
                                getExcel()
                            }}
                        >
                            匯出檔案
                        </Button>,
                        // <Button
                        //     className="bg-[#1976d2] hover:bg-[#4c8bc9] text-white"
                        //     onClick={() => {
                        //         sendMail(selectedRowsInfo)
                        //     }}>
                        //     {t(`send_notification`)}
                        // </Button>
                    ]
                }}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {
                        issue_days_due_status: propsIssueDaysDueStatus === "全部" ? null : propsIssueDaysDueStatus,
                        cardnumber: propsIssueCardnumber,
                    };
                    let order = setOrders(sort);
                    newParams = {
                        ...params,
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    return LibraryCheckoutController.getData(newParams, { useCancelToken: true })
                }}

                rowSelection={{
                    type: "checkbox",
                    selectedRowKeys: selectedRowKeys,
                    selectedRowsInfo: selectedRowsInfo,
                    setSelectedRowKeys: setSelectedRowKeys,
                    setSelectedRowsInfo: setSelectedRowsInfo,
                    ...rowSelection
                }}
                propsPatch={false}
                propsDelete={false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "max-content",
                }}
            />
        </Col>
    </Row>)
}
export { OverdueProcessingTable }
export default OverdueProcessing

